import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ProductInterface } from "../../../interfaces/productInterface";
import { ApiResponse } from "../../../interfaces/apiResponseInterface";
import productApi from "../services/productApi";
import {
  errorNotification,
  successNotification,
} from "../../../utils/notification";
import {
  PRODUCT_MESSAGES_ERROR,
  PRODUCT_MESSAGES_SUCCESS,
} from "../constants/messages";

export const useSaveProductMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<ApiResponse<ProductInterface>, Error, ProductInterface>({
    mutationFn: (product) => productApi.saveProduct(product),
    onSuccess: (res, variables) => {
      if (!res.ok) {
        errorNotification(PRODUCT_MESSAGES_ERROR.SAVE_ERROR);
        return;
      }
      successNotification(PRODUCT_MESSAGES_SUCCESS.SAVE_SUCCESS);
      queryClient.invalidateQueries({ queryKey: ["products-filter"] });
      queryClient.invalidateQueries({ queryKey: ["products"] });
      if (variables._id) {
        queryClient.invalidateQueries({ queryKey: ["product", variables._id] });
      }
    },
    onError: () => {
      errorNotification(PRODUCT_MESSAGES_ERROR.SAVE_ERROR);
    },
  });
};
